"use client";

import {useState} from 'react';

const useCorporateForm = () => {
  const [values, setValues] = useState({
    companyName: '',
    email: '',
    fullname: '',
    phoneno: '',
    noofguests: '',
    message: '',
  });

  const handleChange = (e) => {
    setValues(prevState => {
      return {
        ...prevState,
        [e.target.id]: e.target.value,
      };
    });
  };

  return {values, handleChange};
};

export default useCorporateForm;